// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y7lte1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: var(--spacing-3, 24px);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 16px);
  color: var(--surface-neutral-dark, #1f1f1f);
  text-align: center;
}

.dGWOPG {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1, 8px);
  max-width: 375px;
}

.lcunsB {
  font-weight: var(--font-weight-semibold, 600);
}

.Jsbb7R {
  font-weight: var(--font-weight-regular, 400);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ContentMessage/ContentMessage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,iEAAiE;EACjE,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  gap: var(--spacing-3, 24px);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 16px);\n  color: var(--surface-neutral-dark, #1f1f1f);\n  text-align: center;\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  max-width: 375px;\n}\n\n.title {\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.subtitle {\n  font-weight: var(--font-weight-regular, 400);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `y7lte1`,
	"textContainer": `dGWOPG`,
	"title": `lcunsB`,
	"subtitle": `Jsbb7R`
};
module.exports = ___CSS_LOADER_EXPORT___;
